<template>
  <div class="cell" @click="$emit('click')">
    <slot name='icon'></slot>
    <div class="left">
      <div class="main">{{mainText}}</div>
      <div class="second">{{secondText}}</div>
    </div>
    <div class="right" :style="{color: rightColor}" v-if="!!rightText">{{ rightText }}</div>
    <div class="right-arr" >
      <i class="icon" v-show="rightArraw" :style="{color: rightArrowColor}" >&#xe601;</i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mainText: {
      type: String,
      required: true
    },
    secondText: {
      type: String,
      required: false
    },
    rightText: {
      type: String,
      required: false
    },
    rightColor: {
      type: String,
      default: '#31c27c'
    },
    rightArrowColor: {
      type: String,
      default: '#A0A1A3'
    },
    rightArraw: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../css/var'

.divide-line
  border-bottom 1px solid $divide-line-color

.cell
  height pt(145)
  display flex
  justify-content flex-start
  align-items center
  width 100%
  font-size $normal-font-size
  border-bottom 1px solid $divide-line-color
  .left
    width 6em
    height pt(70)
    flex 1 1 auto
    text-align left
    .main
      vertical-align top
      single-line()
    .second
      vertical-align bottom
      single-line()
      font-size $small-font-size
      color $second-text-color
  .right
    flex 1 1 auto
    text-align right
  .right-arr
    width  pt(20)
    display flex
    justify-content center


</style>




// WEBPACK FOOTER //
// item-double-line.vue?2a98c4c9